import createHistory from "history/createBrowserHistory"
import {store} from "@irati/store"
import {addContext, parseLocation} from "./utils/context"

import {getQuery, getSearchString} from "./searchString"
import BlockNavigationActions from "./utils/store/actions"

export {getQuery, getSearchString}
export {addContext, appOrContext} from "./utils/context"

const browserHistory = createHistory({
  getUserConfirmation(message, callback) {
    store.dispatch(BlockNavigationActions.trigger(callback))
  }
})
export const defaultContext = {appPath: ""}

const history = browserHistory
const push = browserHistory.push
const replace = browserHistory.replace

history.push = (location, context = defaultContext, options = {scrollToTop: true}) => {
  push(addContext(parseLocation(location), context))
  const {scrollToTop} = options
  if (scrollToTop) {
    window.scrollTo(0, 0)
  }
}

history.replace = (location, context = defaultContext, options = {scrollToTop: true}) => {
  replace(addContext(parseLocation(location), context))
  const {scrollToTop} = options
  if (scrollToTop) {
    window.scrollTo(0, 0)
  }
}

export default history
